import React, { useState } from 'react'
import { Box, Collapse, Container, Paper, Stack, Text, UnstyledButton } from '@mantine/core'
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react'
import SectionHeader from './shared/SectionHeader'
import { BRAND_COLOR, FAQ_CONTENT } from '../utils/constants'

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0)

  return (
    <Box id="faq" py={{ base: 60, md: 100 }} style={{ backgroundColor: '#FFFFFF' }}>
      <Container size="md">
        <SectionHeader badge={FAQ_CONTENT.badge} title={FAQ_CONTENT.title} centered />

        <Stack gap="md" mt={40}>
          {FAQ_CONTENT.questions.map((item, index) => {
            const isOpen = openIndex === index
            return (
              <Paper
                key={index}
                radius="lg"
                style={{
                  backgroundColor: '#FFFFFF',
                  border: `1px solid ${isOpen ? BRAND_COLOR + '30' : '#E5E7EB'}`,
                  overflow: 'hidden',
                  transition: 'border-color 0.2s ease',
                }}
              >
                <UnstyledButton
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  style={{
                    width: '100%',
                    padding: '16px 20px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 16,
                  }}
                >
                  <Text size="sm" fw={600} c="#1F2329" style={{ textAlign: 'left' }}>
                    Q{index + 1}：{item.q}
                  </Text>
                  <Box
                    style={{
                      width: 28,
                      height: 28,
                      borderRadius: '50%',
                      backgroundColor: isOpen ? `${BRAND_COLOR}15` : '#F3F4F6',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                      transition: 'background-color 0.2s ease',
                    }}
                  >
                    {isOpen ? (
                      <IconChevronUp size={16} color={BRAND_COLOR} />
                    ) : (
                      <IconChevronDown size={16} color="#6B7280" />
                    )}
                  </Box>
                </UnstyledButton>

                <Collapse in={isOpen}>
                  <Box
                    px={20}
                    pb={16}
                    style={{
                      borderTop: '1px solid #E5E7EB',
                      paddingTop: 16,
                    }}
                  >
                    <Text size="sm" c="#4B5563" style={{ lineHeight: 1.7 }}>
                      {item.a}
                    </Text>
                  </Box>
                </Collapse>
              </Paper>
            )
          })}
        </Stack>
      </Container>
    </Box>
  )
}
